import { EstimationInput } from '../../App';
import { EmissionCategories, throwIfAnyUndefined } from '../calculations';
import { EmissionCalculationInTonnes } from '../../configs/industryCalculationTemplate';

export const calculateHomeOffice = (
  emissionsCategories: EmissionCategories,
  input: EstimationInput,
): EmissionCalculationInTonnes => {
  throwIfAnyUndefined([emissionsCategories.homeoffice_total_tonnes], 'homeoffice');
  const tonnes=emissionsCategories.homeoffice_total_tonnes
  return tonnes;
};
